
import RedpackLeftBottom from '@/components/SkinSlotComponent/c/RedpackLeftBottom.vue'
import { getPhoneTopStyle } from '@/composables/fxwallet'
import config from '@/config'
import { defineComponent, onMounted, reactive, ref, useSlots } from 'vue'

export default defineComponent({
  components: { RedpackLeftBottom },
  props: {
    skin: {
      type: String,
      default: config.skinImage
    }
  },
  setup () {
    const { phoneStyle } = getPhoneTopStyle()

    const slotOther = !!useSlots().other

    // 视窗高度
    const screenHeight = ref(window.innerHeight)

    const footerAnimation = reactive({
      show: false
    })

    const footerTranslateY = reactive({
      finish: 86,
      current: 86,
      max: 86,
      min: 0
    })

    const touch = reactive({
      startY: 0,
      moveY: 0,
      endY: 0
    })

    function touchStartHandler (evt: TouchEvent) {
      touch.startY = evt.touches[0].pageY

      console.log('touchStartHandler', evt)
    }

    function touchmoveHandler (evt: TouchEvent) {
      touch.moveY = touch.startY - evt.touches[0].pageY

      // console.log('touchmoveHandler', touch.moveY, footerTranslateY.finish)

      touch.endY = footerTranslateY.finish - touch.moveY / 40

      if (
        touch.endY < footerTranslateY.min ||
        touch.endY > footerTranslateY.max
      ) {
        return
      }

      footerTranslateY.current = touch.endY
    }

    function touchEndHandler (evt: TouchEvent) {
      if (
        touch.endY < footerTranslateY.min ||
        touch.endY > footerTranslateY.max
      ) {
        return
      }

      if (touch.moveY > 0) {
        footerAnimation.show = true
      }

      if (touch.moveY < 0) {
        footerAnimation.show = false
      }

      animationend()

      console.log(
        'touchEndHandler',
        evt,
        'startY',
        touch.startY,
        'moveY',
        touch.moveY,
        footerAnimation.show,
        footerTranslateY.current
      )
    }

    function animationend () {
      console.log('animationend')

      if (footerAnimation.show) {
        footerTranslateY.finish = footerTranslateY.min
      } else {
        footerTranslateY.finish = footerTranslateY.max
      }

      footerTranslateY.current = footerTranslateY.finish
    }

    onMounted(() => {
      // document.body.addEventListener('touchmove', e => e.preventDefault, { passive: false })
      setTimeout(() => {
        footerAnimation.show = true

        animationend()
      }, 1000)

      window.addEventListener('resize', () => {
        screenHeight.value = window.innerHeight
      }, false)
    })

    return {
      phoneStyle,
      slotOther,
      footerAnimation,
      footerTranslateY,
      touchStartHandler,
      touchmoveHandler,
      touchEndHandler,
      animationend,
      screenHeight
    }
  }
})
